import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func } from 'prop-types'

import ModelIcon from 'Pods/Shared/ModelIcon/ModelIcon'

import { NOOP } from 'Utils/stableDefaults'

// Shared list/links row for the redesigned category mega-menu (Figma `list / links`):
// 48px tall, 20px leading glyph, 14px semibold label. Used by every column (categories,
// type, budget) and the subcategory flyout so all rows stay visually identical. The
// disclosure chevron for expandable categories is a separate <button> sibling (see
// CategoryItem), so this row is always a plain navigable link.
function MegaRow({ href = undefined, label, labelId = undefined, iconSlug = '', className = '', onClick = NOOP }) {
  return (
    <a
      href={href}
      className={classnames('category-mega-menu__row', className)}
      onClick={onClick}
    >
      {iconSlug && (
        <span className="category-mega-menu__row-icon">
          <ModelIcon icon={iconSlug} width="20" height="20" />
        </span>
      )}
      <span id={labelId} className="category-mega-menu__row-label cgt-body-base-semibold">{label}</span>
    </a>
  )
}

MegaRow.propTypes = {
  href: string,
  label: string.isRequired,
  labelId: string,
  iconSlug: string,
  className: string,
  onClick: func,
}

export default memo(MegaRow)
